import { formatNumberHumanize } from "./number";

export const formatDuration = (epoch) => {
  const now = Math.floor(Date.now() / 1000);
  const ageInSeconds = now - epoch / 1000;

  if (ageInSeconds < 60) {
    return `${ageInSeconds}s`;
  } else if (ageInSeconds < 3600) {
    const minutes = Math.floor(ageInSeconds / 60);
    return `${minutes}m`;
  } else if (ageInSeconds < 86400) {
    const hours = Math.floor(ageInSeconds / 3600);
    const minutes = Math.floor((ageInSeconds % 3600) / 60);
    return `${hours}h${minutes}m`;
  } else if (ageInSeconds < 604800) {
    // 7 days
    const days = Math.floor(ageInSeconds / 86400);
    return `${formatNumberHumanize(days, { decimals: 0 })}d`;
  } else if (ageInSeconds < 2592000) {
    // ~30 days
    const weeks = Math.floor(ageInSeconds / 604800);
    return `${formatNumberHumanize(weeks, { decimals: 0 })}w`;
  } else if (ageInSeconds < 31536000) {
    // ~365 days
    const months = Math.floor(ageInSeconds / 2592000);
    return `${formatNumberHumanize(months, { decimals: 0 })}mo`;
  } else if (ageInSeconds < 630720000) {
    const years = Math.floor(ageInSeconds / 31536000);
    return `${formatNumberHumanize(years, { decimals: 0 })}y`;
  } else {
    return "N/A";
  }
};

export const calculateTokenAge = (token) => {
  // Convert all timestamps to Date objects and find the oldest one
  const timestamps = [];

  if (token.seenAt) timestamps.push(new Date(token.seenAt));
  if (token.confirmedAt) timestamps.push(new Date(token.confirmedAt));
  if (token.verifiedAt) timestamps.push(new Date(token.verifiedAt));
  if (token.updatedAt) timestamps.push(new Date(token.updatedAt));
  if (token.tradingAt) timestamps.push(new Date(token.tradingAt));
  if (token.liquidityAt) timestamps.push(new Date(token.liquidityAt));

  // Optional timestamps that can be uncommented if needed
  // if (token.suspiciousAt) timestamps.push(new Date(token.suspiciousAt));
  // if (token.scamAt) timestamps.push(new Date(token.scamAt));
  // if (token.droppedAt) timestamps.push(new Date(token.droppedAt));
  // if (token.pausedAt) timestamps.push(new Date(token.pausedAt));
  // if (token.socialsAt) timestamps.push(new Date(token.socialsAt));

  if (timestamps.length === 0) {
    return "N/A";
  }

  // Find the oldest timestamp
  const oldest = timestamps.reduce((oldest, current) =>
    current < oldest ? current : oldest
  );

  // Calculate age in seconds
  const ageInSeconds = Math.floor((Date.now() - oldest.getTime()) / 1000);

  // Format based on duration
  if (ageInSeconds < 60) {
    return `${formatNumberHumanize(ageInSeconds, { decimals: 0 })}s`;
  } else if (ageInSeconds < 3600) {
    const minutes = Math.floor(ageInSeconds / 60);
    return `${formatNumberHumanize(minutes, { decimals: 0 })}m`;
  } else if (ageInSeconds < 86400) {
    const hours = Math.floor(ageInSeconds / 3600);
    const minutes = Math.floor((ageInSeconds % 3600) / 60);
    return `${formatNumberHumanize(hours, { decimals: 0 })}h${formatNumberHumanize(minutes, { decimals: 0 })}m`;
  } else if (ageInSeconds < 604800) {
    // 7 days
    const days = Math.floor(ageInSeconds / 86400);
    return `${formatNumberHumanize(days, { decimals: 0 })}d`;
  } else if (ageInSeconds < 2592000) {
    // ~30 days
    const weeks = Math.floor(ageInSeconds / 604800);
    return `${formatNumberHumanize(weeks, { decimals: 0 })}w`;
  } else if (ageInSeconds < 31536000) {
    // ~365 days
    const months = Math.floor(ageInSeconds / 2592000);
    return `${formatNumberHumanize(months, { decimals: 0 })}mo`;
  } else if (ageInSeconds < 630720000) {
    const years = Math.floor(ageInSeconds / 31536000);
    return `${formatNumberHumanize(years, { decimals: 0 })}y`;
  } else {
    return "N/A";
  }
};
